import { render } from "./CartImportXlsModal.vue?vue&type=template&id=54765e0e"
import script from "./CartImportXlsModal.vue?vue&type=script&lang=js"
export * from "./CartImportXlsModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/etos-b2b/b2b-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__